/**
 * `/launch` — the post-login module launcher (ADR-0049).
 *
 * Deliberately OUTSIDE the `(workspace)` layout group: the launcher is the
 * level above the workspace chrome (no sidebar / topbar / section tabs),
 * the same chrome-less pattern as `/pos`. Auth is enforced by the root
 * route's `beforeLoad` guard (session + company required); entering any
 * tile lands on a `(workspace)/*` page where the chrome mounts.
 *
 * Reached from: OTP sign-in (existing members), the onboarding "done"
 * hand-off, and the brand mark in the workspace top bar / sidebar rail.
 *
 * @see prototype/explorations/module-launcher.html — design baseline
 * @see docs/adr/0037-module-launcher-landing.md
 */
import { createFileRoute } from "@tanstack/react-router";
import { LauncherPage } from "../features/workspace/index.ts";

export const Route = createFileRoute("/launch")({
  component: LauncherPage,
});
